import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { KuiModule } from 'app/key-ui';
import { Ng2FilterPipeModule } from 'ng2-filter-pipe';
import { SharedModule } from 'app/shared/shared.module';
import { OverviewListComponent } from './components/list/list.component';
import { OverviewMapComponent } from './components/map/map.component';
import { KeyMapModule, MapSetService, KeyFilterPanelModule } from 'app/shared/components';
import { OverviewDetailsComponent } from './components/details/details.component';
import { KeyDetailsOverviewSummaryComponent } from './components/details/details-overview-summary/details-overview-summary.component';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { TranslateModule } from '@ngx-translate/core';
import { UnitsPipe } from 'app/shared/pipes';
import { OverviewDetailsResolver } from './components/details/details.routing';
import { KeyDetailsSidebarComponent } from 'app/pages/status/overview/components/details/details-sidebar/details-sidebar.component';
import { LocationSelectModalComponent } from 'app/shared/components/modal/location-select-modal/location-select-modal.component';
import { LocationSelectModalModule } from 'app/shared/components/modal/location-select-modal/location-select.module';
import { SharingModalComponent } from './components/details/sharing/share-modal.component';
import { OverviewDetailsVideoComponent } from './components/details/details-video/details-video.component';

const COMPONENTS = [
    OverviewListComponent,
    OverviewMapComponent,
    OverviewDetailsComponent,
    KeyDetailsOverviewSummaryComponent,
    KeyDetailsSidebarComponent,
    SharingModalComponent,
    OverviewDetailsVideoComponent,
];


@NgModule({
    imports: [
        CommonModule,
        KuiModule,
        SharedModule,
        FormsModule,
        Ng2FilterPipeModule,
        PipeModule.forRoot(),
        KeyMapModule,
        KeyFilterPanelModule,
        LocationSelectModalModule,
        TranslateModule.forChild(),
    ],
    declarations: COMPONENTS,
    exports: COMPONENTS,
    providers: [
        UnitsPipe,
        MapSetService,
        OverviewDetailsResolver,
    ],
    entryComponents: [LocationSelectModalComponent, SharingModalComponent],
})
export class SharedOverViewPageModule { }
